<template>
  <div>
    <Credentials />
    <AssignedMembers v-if="$isSectionEnabled('access','access_control') && $hasProjectAccessFor([$pRole.ADMIN, $pRole.USER, $pRole.GUEST])" />
    <GroupInvitation v-if="$hasProjectAccessFor([$pRole.ADMIN])" />
    <AskMairaAccess v-if="$hasProjectAccessFor([$pRole.ADMIN])" />
    <IpAccess v-if="$hasProjectAccessFor([$pRole.ADMIN])" />
  </div>
</template>


<script>
import jwt_decode from "jwt-decode";
import { mapState } from "vuex";

import AskMairaAccess from "@/views/access/AskMairaAccess.vue";
import AssignedMembers from "@/views/access/AssignedMembers.vue";
import Credentials from "@/views/access/Credentials.vue";
import GroupInvitation from "@/views/access/GroupInvitation.vue";

import IpAccess from "./IpAccess.vue";

export default {
  components: {
    AssignedMembers,
    Credentials,
    GroupInvitation,
    IpAccess,
    AskMairaAccess
  },
  data() {
    return {


    }
  },
  computed: {
    ...mapState({
      selectedProject: state => state.project.selectedProject,
      organization: state => state.account.organization,
      user: (state) => state.account.user, // FIXME we shouldn't store and access user credentials from vuex store. Always use directly from localStorage
    }),
    showAccessControl(){
      const accountRoles = this.accountRoles()

      if( accountRoles.includes("admin") || this.organization?.is_account_owner){
        return true
      }
      return false
    },
  },
  watch: {

  },
  methods: {
    accountRoles() {
      return jwt_decode(this.user.access_token)["scope"];
    },
  },

}
</script>

<style>
</style>
